import { createContext, useContext, useState } from "react";

const CompanyCompareContext = createContext();

export function CompanyCompareProvider({ children }) {
  const [companyCompareList, setCompanyCompareList] = useState([]);

  function toggleCompanyCompare(company) {
    setCompanyCompareList((prev) => {
      const exists = prev.find((c) => c.companyId === company.companyId);
      if (exists) return prev.filter((c) => c.companyId !== company.companyId);
      if (prev.length >= 3) return prev;
      return [...prev, {
        companyId: company.companyId,
        companyName: company.companyName,
      }];
    });
  }

  function removeCompanyCompare(companyId) {
    setCompanyCompareList((prev) => prev.filter((c) => c.companyId !== companyId));
  }

  function clearCompanyCompare() {
    setCompanyCompareList([]);
  }

  function isInCompanyCompareList(companyId) {
    return companyCompareList.some((c) => c.companyId === companyId);
  }

  return (
    <CompanyCompareContext.Provider value={{
      companyCompareList,
      toggleCompanyCompare,
      removeCompanyCompare,
      clearCompanyCompare,
      isInCompanyCompareList,
    }}>
      {children}
    </CompanyCompareContext.Provider>
  );
}

export function useCompanyCompare() {
  return useContext(CompanyCompareContext);
}
